import {MetricsResource} from 'common/report/model-resources/metrics';
import {contextify, createRootContextHook} from 'common/util/react';

const context = contextify<MetricsResource>();

export const MetricsResourceProvider = context.Provider;
export const MetricsResourceConsumer = context.Consumer;
export const useMetrics = createRootContextHook(`metrics`);
